import PersonIcon from '@mui/icons-material/Person'
import styled from 'styled-components'

import { getIsAuthorized } from '../core/AccountProvider'
import navigate from '../core/navigate.js'
import { useAccountQuery } from '../core/queries'
import UnstyledLogo from './Logo'
import MobileNavigationBar from './MobileNavigationBar'
import MobileNotifications from './MobileNotifications'
import Search from './Search'

const MobileHeader = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  background-color: white;
  z-index: ${props => props.theme.zIndex.fixed};
`

const Logo = styled(UnstyledLogo)`
  flex: 0 1 30px;
  height: 40px;
  width: 80px;
  position: relative;
  left: -5px;
  padding-right: 4px;
`

const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
  column-gap: 6px;
  align-items: center;
`

const SearchWrapper = styled.div`
  display: inline-flex;
  width: 100%;
`

const AccountButton = styled.button`
  height: 38px;
  width: 38px;
  line-height: 0.5;
  border-radius: 4px;
  padding: 5px;
  margin-left: 4px;
  font-size: 22px;
  background-color: ${props => props.theme.palette.secondary.main};
  color: white;
  border: none;
  transition: all 0.3s;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  line-height: 0.5;
  border-radius: 4px;
  user-select: none;

  &:disabled {
    background-color: ${props => props.theme.palette.secondary.light};
  }
`

export default ({
  handleAccountAccordion,
  handleItemsForSaleAccordion,
  handleEquipmentAccordion,
  showFilter,
  children
}) => {
  useAccountQuery()

  const handleAccountClick = () => {
    if (getIsAuthorized()) return handleAccountAccordion()

    const { pathname, search } = window.location

    // If not on /account/login or /account/register page...
    if (!pathname.match(/^\/account\/(login|register)/))
      navigate(`/account/login?return=${pathname}${search}`)
  }

  return (
    <>
      <MobileHeader>
        <Logo id='header_logo' />
        <Wrapper>
          <SearchWrapper>
            <Search />
          </SearchWrapper>
          <MobileNotifications />
          <AccountButton id='header_account_button' onClick={handleAccountClick}>
            <PersonIcon sx={{ fontSize: '24px' }} />
          </AccountButton>
        </Wrapper>
        {children}
      </MobileHeader>
      <MobileNavigationBar
        handleItemsForSaleAccordion={handleItemsForSaleAccordion}
        handleEquipmentAccordion={handleEquipmentAccordion}
        showFilter={showFilter}
      />
    </>
  )
}
